import _ from 'lodash';
import env from '../../env';
import { AppClientId } from '../Shared/constants';

export const TRANSPORTER_DOMAIN = 'app/modules/Contents/TRANSPORTER_DOMAIN';

export const REQUEST_TRANSPORTER_CREATE = 'app/modules/Contents/REQUEST_TRANSPORTER_CREATE';
export const REQUEST_TRANSPORTER_EDIT = 'app/modules/Contents/REQUEST_TRANSPORTER_EDIT';
export const REQUEST_DELETE_TRANSPORTER = 'app/modules/Contents/REQUEST_DELETE_TRANSPORTER';
export const REQUEST_TRANSPORTERS = 'app/modules/Contents/REQUEST_TRANSPORTERS';
export const REQUEST_TRANSPORTER = 'app/modules/Contents/REQUEST_TRANSPORTER';
export const INITIATE_TRANSPORTER_CREATE = 'app/modules/Contents/INITIATE_TRANSPORTER_CREATE';
export const INITIATE_TRANSPORTER_EDIT = 'app/modules/Contents/INITIATE_TRANSPORTER_EDIT';
export const SET_NEW_TRANSPORTER_VALUE = 'app/modules/Contents/SET_NEW_TRANSPORTER_VALUE';

export const REQUEST_TRANSPORTER_PROPERTY_UPDATE = 'app/modules/Contents/REQUEST_TRANSPORTER_PROPERTY_UPDATE';

export const FILTER_DEFAULT_LIMIT = 50;

export const REQUEST_TRANSPORTER_FILTER = 'app/modules/Contents/REQUEST_TRANSPORTER_FILTER';
export const APPLY_TRANSPORTER_FILTERS = 'app/modules/Contents/APPLY_TRANSPORT_ORDER_FILTERS';
export const SET_TRANSPORTER_SORT = 'app/modules/Contents/SET_TRANSPORT_ORDERS_SORT';
export const REQUEST_TRANSPORTER_FILTER_RESET = 'app/modules/Contents/REQUEST_TRANSPORT_ORDER_FILTER_RESET';
export const UPDATE_TRANSPORTER_FILTERS = 'app/modules/Contents/UPDATE_TRANSPORT_ORDER_FILTERS';
export const UPDATE_TRANSPORTER_SEARCH_STRING = 'app/modules/Contents/UPDATE_TRANSPORT_ORDER_SEARCH_STRING';

// TRANSPORTER
export const TRANSPORTER_FIELD_TYPES = ['name', 'surname', 'phoneNumber', 'email', 'remarks'];
